import { createContext } from 'react';
import { CLH_SESSION_ID } from './helpers';
var initialContext = {
    isLoading: true,
    clhSessionId: CLH_SESSION_ID,
};
export var AccessTokenContext = createContext(initialContext);
